import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import {
  SignIn,
  Banner,
  CounselingDate,
  CounselingInfo,
  EventReservation,
  EventCashback,
  WeddingHall,
  WeddingDate,
  EventImage,
  InquiryBoxList,
  EventHotelImage,
  RecommendWeddingHall,
  CompanyReviewDetailPage,
  CompanyDetailPage,
  EventReferralImage,
  UploadCompanyReviewPage,
} from "./pages";
import * as Pages from "./pages";
import { useEffect } from "react";
import {
  headerAndBottomVisibleState,
  navigationState,
  OSState,
  signOnState,
} from "recoil/atoms";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import KakaoLogin from "pages/KakaoLogin";
import SignOn from "pages/SignOn/SignOn";
import PDFPage from "./pages/PDFPage";
import useUser from "hooks/useUser";
import { api, getToken } from "utils/ApiUtil";
import {
  getParameter,
  getParameterObject,
  isAndroid,
  isIos,
} from "utils/common";
import { PointApplyPage } from "pages/PointAppyPage";
import { CompanyPage } from "pages/CompanyPage";
import useInitData from "hooks/useInitData";
import { modalState } from "recoil/modal";
import { InquiryDetailPage } from "pages/InquiryDetailPage";
import ChannelService from "ChannelService";
import "./ReactToastify.css";
import MyPointApplyListPage from "pages/PointAppyPage/MyPointApplyListPage";
import MyProfilePage from "pages/MyProfilePage/MyProfilePage";
import { envUtil, ScreenId } from "utils";
import { EtcInsertEntryInfoPage } from "pages/EtcInsertEntryInfoPage";
import { SelectClothesPage, SelectSpotPage } from "pages/SelectSpotPage";
import { headerState } from "recoil/header";

function App() {
  const { user, getUser } = useUser();
  const action = useNavigationType();
  const location = useLocation();
  const setHeader = useSetRecoilState(headerState);
  const [activeNav, setActiveNav] = useRecoilState(navigationState);
  const [signOnData, setSignOnData] = useRecoilState(signOnState);
  const pathname = location.pathname;
  const { getInquiryList } = useInitData();
  const headerAndBottomVisible = useRecoilValue(headerAndBottomVisibleState);
  const { isBottom } = headerAndBottomVisible;
  const setOSState = useSetRecoilState(OSState);

  function checkUser(page: JSX.Element) {
    if (user) {
      return page;
    } else {
      return <SignIn />;
    }
  }

  useEffect(() => {
    if (action !== "POP") {
      window.document.getElementById("wrapper")?.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    switch (pathname) {
      case "/":
        setActiveNav("detail");
        setHeader({ isVisible: true, title: "홈", left: "back" });
        break;
      case "/banner":
        setActiveNav("home");
        setHeader({ isVisible: true, title: "웨딩홀 예약센터", left: "back" });
        break;
      case "/company":
        setActiveNav("detail");
        setHeader({ isVisible: true, title: "홈", left: "back" });
        break;
      case "/banner/eventcashback":
        setHeader({ isVisible: true, title: "캐시백 안내", left: "back" });
        break;
      case "/banner/eventimage":
        setHeader({
          isVisible: true,
          title: "커피 쿠폰 이벤트",
          left: "back",
        });
        break;
      case "/banner/eventReferral":
        setHeader({
          isVisible: true,
          title: "추천인 이벤트",
          left: "back",
        });
        break;
      case "/banner/eventhotelimage":
        setHeader({
          isVisible: true,
          title: "5성급 호텔 캐시백 이벤트",
          left: "back",
        });
        break;
      case "/counseling/date":
      case "/counseling/info":
        setActiveNav("company");
        setHeader({ isVisible: true, title: "예약 문의", left: "back" });
        break;
      case "/wedding/hall":
        setActiveNav("company");
        setHeader({ isVisible: true, title: "웨딩홀 선택", left: "back" });
        break;
      case "/wedding/date":
        setActiveNav("company");
        setHeader({ isVisible: true, title: "예식 일정 선택", left: "back" });
        break;
      case "/SignOn":
        setHeader({ isVisible: true, title: "회원가입", left: "back" });
        break;

      // case "/SignIn/InquiryBoxList":
      //   setHeader({ isVisible: true, title: "문의내역", left: "back" });
      //   break;
      // case "/SignIn/InquiryBoxList/detail":
      //   setHeader({ isVisible: true, title: "문의 상세내역", left: "back" });
      //   break;
      case "/company/detail":
        setHeader({ isVisible: true, title: "상세페이지", left: "back" });
        break;
      case "/company/detail/Spotlist":
        setHeader({ isVisible: true, title: "지점선택", left: "back" });
        break;
      case "/company/detail/SelectClothes":
        setHeader({ isVisible: true, title: "선택사항", left: "back" });
        break;
      case ScreenId.MY_PROFILE:
        setHeader({ isVisible: true, title: "내 정보 수정", left: "back" });
        break;
      case ScreenId.PROMOTION:
        setHeader({ isVisible: false });
        break;
      case ScreenId.PROMOTION_B2B:
        setHeader({ isVisible: true, title: "임직원 인증", left: "back" });
        break;
      case ScreenId.PROMOTION_KAKAO:
        setHeader({ isVisible: true, title: "오픈 카톡방 인증", left: "back" });
        break;

      default:
        setHeader({ isVisible: false });
        break;
    }
    if (pathname.includes("PDF")) {
      setHeader({ isVisible: true, title: "개인정보 동의", left: "back" });
    }

    if (pathname !== "/SignOn") {
      setSignOnData(undefined);
    }
  }, [pathname]);

  useEffect(() => {
    const token = getToken();
    if (token) {
      getUser();
    } else {
      const app_token = getParameter({
        url: window.location.search,
        key: "token",
      });
      if (app_token) {
        api.setToken(app_token);
        getUser();
      }
    }

    getInquiryList("wedding");
    getInquiryList("etc");
  }, []);

  useEffect(() => {
    const { token } = getParameterObject({ url: location.search });
    const { OS } = getParameterObject({ url: location.search });
    if (token) {
      api.setToken(token);
      getUser();
    }
    if (OS) {
      setOSState(String(OS));
    }
  }, [location.search]);

  // 채널톡
  useEffect(() => {
    if (isAndroid() || isIos()) {
      window.ChannelIO?.("boot", {
        pluginKey: envUtil.CHANNELTALK.KEY,
        customLauncherSelector: ".channel-recommand-button",
        hideChannelButtonOnBoot: true,
        zIndex: 100,
        memberId: user?.user_no.toString(),
        profile: {
          user_no: user?.user_no,
          name: user?.name,
          nickname: user?.nickname,
          phone_number: user?.phone_number,
        },
      });
    } else {
      ChannelService.loadScript();
      ChannelService.boot({
        pluginKey: envUtil.CHANNELTALK.KEY,
        customLauncherSelector: ".channel-recommand-button",
        memberId: user?.user_no.toString(),
        zIndex: 100,
        profile: {
          user_no: user?.user_no,
          name: user?.name,
          nickname: user?.nickname,
          phone_number: user?.phone_number,
        },
      });
    }
  }, []);

  return (
    <Routes>
      <Route path="/" element={<CompanyPage />} />
      <Route path="/banner" element={<Banner />} />
      <Route path="/recommend" element={<RecommendWeddingHall />} />

      <Route path="/company/detail" element={<CompanyDetailPage />} />
      <Route
        path="/company/detail/review/:review_no/:contructor_no"
        element={<CompanyReviewDetailPage />}
      />
      <Route
        path="/company/detail/review/reviewwrite"
        element={checkUser(<UploadCompanyReviewPage />)}
      />
      <Route path="/event/reservation" element={<EventReservation />} />
      <Route path="/banner/eventcashback" element={<EventCashback />} />
      <Route path="/banner/eventimage" element={<EventImage />} />
      <Route path="/banner/eventhotelimage" element={<EventHotelImage />} />
      <Route path="/banner/eventReferral" element={<EventReferralImage />} />

      <Route path="/wedding/hall" element={<WeddingHall />} />

      <Route path="/wedding/date" element={checkUser(<WeddingDate />)} />
      <Route path="/counseling/date" element={checkUser(<CounselingDate />)} />
      <Route path="/counseling/info" element={checkUser(<CounselingInfo />)} />
      <Route path="/kakaoLogin" element={<KakaoLogin />} />
      <Route path="/PDFPage/:key" element={<PDFPage />} />

      <Route
        path="/SignIn/InquiryBoxList"
        element={checkUser(<InquiryBoxList />)}
      />
      <Route path="/company/detail/Spotlist" element={<SelectSpotPage />} />
      <Route
        path="/company/detail/SelectClothes"
        element={<SelectClothesPage />}
      />
      <Route
        path="/SignIn/InquiryBoxList/detail"
        element={checkUser(<InquiryDetailPage />)}
      />
      <Route
        path="/SignIn/MyPointList/PointApplyPage"
        element={checkUser(<PointApplyPage />)}
      />
      <Route
        path="/SignIn/MyPointList"
        element={checkUser(<MyPointApplyListPage />)}
      />
      <Route
        path="/SignIn/MyProfilePage"
        element={checkUser(<MyProfilePage />)}
      />
      <Route
        path="/company/detail/insertEntryInfoPage"
        element={<EtcInsertEntryInfoPage />}
      />
      <Route path="/SignOn" element={!!signOnData ? <SignOn /> : <SignIn />} />
      <Route path="/SignIn" element={<SignIn />} />
      <Route path="/SignIn" element={<SignIn />} />
      <Route
        path={`${ScreenId.PROMOTION}`}
        element={<Pages.PromotionLandingPage />}
      />
      <Route
        path={ScreenId.PROMOTION_B2B}
        element={checkUser(<Pages.B2bPromotionPage />)}
      />
      <Route
        path={ScreenId.PROMOTION_KAKAO}
        element={checkUser(<Pages.KakaoPromotionPage />)}
      />
      <Route path="*" element={<SignIn />} />
    </Routes>
  );
}
export default App;
